module.exports = __webpack_public_path__ + "img/tabs.cfe6763e.svg";